import Model from '@models/Model'
import Country from '@models/Country'
import PersonRole from '@models/PersonRole'
import User from '@models/User'

class Person extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'name',
        'email',
        'user_id',
        'country_id',
        'discarded_at',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'discarded_at',
        'created_at',
        'updated_at',
      ],
      relationships: {
        country: { collection: false, model: Country },
        person_roles: { collection: true, model: PersonRole },
        user: { collection: false, model: User },
      },
    })
  }
}

export default Person
